import React from 'react';
import { logError } from 'src/services/errorLogger';
import { endpoints } from 'src/utils/axios';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError(
      {
        type: 'react_component_error',
        message: error?.message || 'React component error',
        stack_trace: error?.stack || '',
        meta: { component_stack: errorInfo?.componentStack || '' },
      },
      endpoints.system_errors
    );
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <main role="alert" style={{ padding: 40 }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page and try again.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Refresh page
          </button>
        </main>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
